import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';
import {Button, Space} from "antd";

const StyledInvoiceSelector = styled.div`
  ${bordersStyles.light};

  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;

const StyledInvoiceSelectorBr = styled.div`
  text-align: center;

  &:before,&:after {
    background-color: ${props => props.theme.colors.neutral_4};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: calc(100% / 2 - 15px);
  }
  &:before {
    right: 0.5em;
  }
  &:after {
    left: 0.5em;
  }
`;

const StyledInvoiceSelectorEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StyledInvoiceSelectorEmptyText = styled.span`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledInvoiceSelectorFormContainer = styled.div`
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  flex-direction: column;
  width: 100%;

  & > .ant-space {
    width: 100%;
    & > .ant-space-item {
      width: 100%;
    }
  }
`;

const StyledInvoiceSelectorFormContainerButtons = styled.div`
  text-align: center;
`;

const StyledInvoiceSelectorFormSpace = styled(Space)`
  justify-content: space-between;
  width: 100%;

  form {
    min-width: 100px;
  }

  svg {
    path {
      fill: ${props => props.theme.colors.neutral_6};
    }
  }

  .ant-space-item {
    display: flex;
  }

  .placeholder {
    height: 42px;
    width: 42px;
  }
`;

const StyledInvoiceSelectorIconButton = styled(Button)`
  align-items: center;
  display: flex;
  justify-content: center;

  &.ant-btn-sm {
    height: 16px;
    width: 16px;
  }

  svg {
    height: 12px;
    width: 12px;

    path {
      fill: ${props => props.theme.colors.neutral_7};
      transition: .2s ease;
    }
  }

  &.remove-invoice-button {
    svg {
      height: 16px;
      width: 16px;
    }
  }

  .ant-btn-icon {
    display: flex;
  }
`;

export {
  StyledInvoiceSelector,
  StyledInvoiceSelectorBr,
  StyledInvoiceSelectorEmpty,
  StyledInvoiceSelectorEmptyText,
  StyledInvoiceSelectorFormContainer,
  StyledInvoiceSelectorFormContainerButtons,
  StyledInvoiceSelectorFormSpace,
  StyledInvoiceSelectorIconButton,
};
